import { Container, Typography } from '@mui/material'
import { ReactElement } from 'react'

export default function CreateCourseV5Detail(): ReactElement {
  return (
    <Container maxWidth="xl" className="py-6">
      <Typography variant="h4" component="h1" className="mb-3">
        Course Detail
      </Typography>
    </Container>
  )
}
